import { render, staticRenderFns } from "./identification-summary.vue?vue&type=template&id=75b78400&scoped=true"
import script from "./identification-summary.vue?vue&type=script&lang=ts"
export * from "./identification-summary.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b78400",
  null
  
)

export default component.exports